// extracted by mini-css-extract-plugin
export var readonly = "_j8-1";
export var star = "_j8-0";